import { JudgeNullPipe } from './judge-null.pipe';
import { NgModule } from '@angular/core';
import { ThousandSeparatorPipe } from './thousand-separator.pipe';
import { UtcToLocalPipe } from './utc-to-local.pipe';



@NgModule({
  declarations: [
    JudgeNullPipe,
    ThousandSeparatorPipe,
    UtcToLocalPipe
  ],
  exports: [
    JudgeNullPipe,
    ThousandSeparatorPipe,
    UtcToLocalPipe
  ]
})
export class CommonPipeModule { }
